import axios from "axios";

export const customFetch = axios.create({
  headers: {
  Accept: "application/json"
},
  baseURL: "https://v2nportal.com/fortressServerMiddleWare/",
});
